import { Avatar, AvatarGroup, Drawer } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  getCompany,
  getInternshipRequest,
  getInternStudent,
  getDocumentRequest,
  getDocumentReqStudent,
} from "../../api/crud";
import { useNavigate } from "react-router-dom";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { optionsBranch } from "../../data/branch-data";
import { internType } from "../../data/interntype-data";
import { convertDateToString, matchOptions } from "../../utils/function";
import DrawerView from "../DrawerView";
import FormReview from "../FormReview";
import InternData from "../InternData";
import ModalView from "../ModalView";
import ProfileDetail from "../ProfileDetail";
import { IoMdRemoveCircle } from "react-icons/io";
import DrawerReviewCompany from "./DrawerReviewCompany";
import FormReviewCompleted from "../FormReviewCompleted";
import FormResponse from "../FormResponse";
import { useSelector } from "react-redux";
import _ from "lodash";
import ActivityLog from "../ActivityLog";
import ModalGetDocument from "./ModalGetDocument";
import InternPersonsQty from "../InternPersonsQty";

const DocumentCompleted = () => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const navigate = useNavigate();
  const [documentRequested, setDocumentRequested] = useState([]);
  const [documentRequestedFilter, setDocumentRequestedFilter] = useState([]);
  const [isOpenDrawerFormRequest, setIsOpenDrawerFormRequest] = useState(false);
  const [isOpenDrawerFormResponse, setIsOpenDrawerFormResponse] =
    useState(false);
  const [isModalProfileOpen, setIsModalProfileOpen] = useState(false);
  const [isModalGetDocOpen, setIsModalGetDocOpen] = useState(false);
  const [docSelected, setDocSelected] = useState(null);
  const [studentIdSelected, setStudentIdSelected] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [docTypeSelected, setDocumentTypeSelected] = useState(1);
  const [cardSelected, setCardSelected] = useState(null);
  const [studentIdInput, setStudentIdInput] = useState("");
  const [studentDetail, setStudentDetail] = useState({ id: 0 });
  const [onAction, setOnAction] = useState("edit");
  const [studentSelected, setStudentSelected] = useState(null);
  const [companyWithIntern, setCompanyWithIntern] = useState([]);

  const styles = {
    stamp: {
      // border: "2px solid red",
      textAlign: "center",
      padding: "5px",
      color: "red",
      // borderRadius: "15px",
    },
  };

  const onSelectDoc = (doc) => {
    setIsOpenDrawerFormRequest(true);
    setDocSelected(doc);
  };

  const onSelectDocResponse = (doc) => {
    setIsOpenDrawerFormResponse(true);
    setDocSelected(doc);
  };

  const onSubmitCheckStudent = (ev) => {
    ev.preventDefault();
    const getStudentDetail = cardSelected.internStd.find(
      (st) => st.st_id == studentIdInput
    );

    setStudentDetail(getStudentDetail ?? { id: 0, name: "ไม่พบข้อมูล" });
  };

  const getData = async () => {
    const documentRequest = await getDocumentRequest();
    const internStudent = await getInternStudent();
    const allCompany = await getCompany();
    const internshipRequest = await getInternshipRequest();
    const documentReqStudent = await getDocumentReqStudent();

    const group = _.groupBy(documentReqStudent, (ev) => ev.idm_id);

    const docreqTest = documentRequest.map((item) => {
      return {
        ...item,
        internStd: group[item.idm_doc_id],
      };
    });

    const mapDocreqTest = docreqTest.map((item) => {
      const internStd = item.internStd.map((el) => {
        return {
          ...el,
          internStudent: internStudent.find((st) => st.id == el.st_id),
          internshipRequest: internshipRequest.find(
            (st) => st.st_id == el.st_id
          ),
        };
      });

      return {
        ...item,
        companyDetail: allCompany.find((el) => el.id == item.cp_id),
        internStd,
      };
    });

    const studentDetail = internStudent.map((st) => {
      const find = internshipRequest.find((el) => el.st_id == st.id);

      return {
        ...st,
        internDetail: find,
      };
    });

    const companyWithStd = allCompany.map((company) => {
      const internSt = studentDetail.filter(
        (st) => st.internDetail?.cp_id == company.id
      );

      return {
        ...company,
        internStudent: internSt,
      };
    });

    setCompanyWithIntern(companyWithStd);

    const docReq = documentRequest.map((item) => {
      const findCompany = companyWithStd.find((cp) => cp.id == item.cp_id);

      return {
        ...item,
        companyDetail: findCompany,
      };
    });

    const filterData = mapDocreqTest.filter((res) => {
      return res.idm_status == 1;
    });

    setDocumentRequested(mapDocreqTest);
    setDocumentRequestedFilter(filterData);
  };

  const onHandleClickTab = (statusNum) => {
    setActiveTab(statusNum);

    const filterData = documentRequested.filter((res) => {
      return res.idm_status == statusNum;
    });

    console.log("fil",filterData);

    setDocumentRequestedFilter(filterData);
  };

  const displayProfile = (
    <Drawer
      anchor="right"
      open={studentSelected ? true : false}
      onClose={() => setStudentSelected(null)}
    >
      <div
        className="card-body shadow-lg"
        style={{ width: "80vw", maxWidth: "600px" }}
      >
        <div className="row g-0">
          <div className="col-12 mb-4">
            <ProfileDetail st_id={studentSelected?.st_id} />
          </div>
          <div className="col-12 ">
            <InternData st_id={studentSelected?.st_id} />
          </div>
        </div>

        <hr />
        <ActivityLog />
      </div>
    </Drawer>
  );

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <h3 className="">หนังสือขอความอนุเคราะห์ฝึกงาน</h3>
        </div>
        <div className="card-body">
          <ul className="nav nav-tabs" style={{ height: "35px" }}>
            <li className="nav-item">
              <span
                className={`nav-link ${
                  activeTab == 1 ? "active text-primary" : "text-dark"
                }`}
                type="button"
                onClick={() => {
                  onHandleClickTab(1);
                }}
              >
                เตรียมออกหนังสือ
              </span>
            </li>
            <li className="nav-item">
              <span
                className={`nav-link ${
                  activeTab == 2 ? "active text-primary" : "text-dark"
                }`}
                type="button"
                onClick={() => onHandleClickTab(2)}
              >
                ออกหนังสือแล้ว
              </span>
            </li>
            <li className="nav-item">
              <span
                className={`nav-link ${
                  activeTab == 3 ? "active text-primary" : "text-dark"
                }`}
                type="button"
                onClick={() => onHandleClickTab(3)}
              >
                นิสิตรับหนังสือแล้ว
              </span>
            </li>
            <li className="nav-item ">
              <span
                className={`nav-link  ${
                  activeTab == 0 ? "active text-primary" : "text-dark"
                }`}
                type="button"
                onClick={() => onHandleClickTab(0)}
              >
                หนังสือที่ยกเลิก
              </span>
            </li>
          </ul>

          <div id="tasks-upcoming">
            {!!documentRequestedFilter.length &&
              documentRequestedFilter.map((el, index) => {
                return (
                  <div key={index} className="card mb-3 bg-light  border">
                    <form
                      action="./update-status-get-document.php"
                      method="post"
                    >
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between  mb-2 align-items-center">
                          <div className="d-flex flex-wrap">
                            <div className="badge bg-success me-2">
                              Doc ID : {el?.idm_doc_id}
                            </div>
                            <div>
                              <span>{el?.companyDetail?.name}</span>
                              <InternPersonsQty
                                companyDetail={companyWithIntern.find(
                                  (c) => c.id == el.companyDetail.id
                                )}
                              />
                            </div>
                          </div>

                          <div>
                            {el?.idm_status != 0 && (
                              <div className="dropdown">
                                <BiDotsVerticalRounded
                                  size="1.5rem"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                />
                                <ul className="dropdown-menu">
                                  {activeTab == 1 && (
                                    <li>
                                      <button
                                        className="dropdown-item "
                                        type="submit"
                                        onClick={() => {
                                          setDocumentTypeSelected(1);
                                        }}
                                      >
                                        ให้นิสิตมารับหนังสือ
                                      </button>
                                    </li>
                                  )}
                                  {activeTab == 2 && (
                                    <li>
                                      <div
                                        className="dropdown-item"
                                        onClick={() => {
                                          setIsModalGetDocOpen(true);
                                          setCardSelected(el);
                                        }}
                                      >
                                        นิสิตรับหนังสือ
                                      </div>
                                    </li>
                                  )}

                                  <li>
                                    <form
                                      action={
                                        onAction == "edit"
                                          ? "./edit-document-internship.php"
                                          : onAction == "cancel-document"
                                          ? "./cancel-document-internship.php"
                                          : onAction == "cancel-request"
                                          ? "./cancel-request-internship.php"
                                          : ""
                                      }
                                      method="post"
                                    >
                                      <span className="d-none">
                                        {el?.internStd?.map((st) => {
                                          return (
                                            <>
                                              <input
                                                value={st?.st_id}
                                                name="st_id[]"
                                              />
                                              <input
                                                value={
                                                  st?.internshipRequest?.req_id
                                                }
                                                name="req_id[]"
                                              />
                                            </>
                                          );
                                        })}
                                        <input
                                          value={el?.idm_doc_id}
                                          name="idm_doc_id"
                                        />
                                        <input
                                          value={studentIdSelected}
                                          name="user"
                                        />
                                      </span>
                                      <button
                                        type="submit"
                                        className="dropdown-item text-warning"
                                        onClick={() => setOnAction("edit")}
                                      >
                                        แก้ไขเอกสาร
                                      </button>
                                      <hr />

                                      <button
                                        type="submit"
                                        onClick={() =>
                                          setOnAction("cancel-document")
                                        }
                                        className="dropdown-item text-danger"
                                      >
                                        ยกเลิกหนังสือ
                                      </button>
                                      <button
                                        type="submit"
                                        onClick={() =>
                                          setOnAction("cancel-request")
                                        }
                                        className="dropdown-item text-danger"
                                      >
                                        ยกเลิกคำร้อง
                                      </button>
                                    </form>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>

                        <div>
                          <AvatarGroup total={el?.internStd?.length}>
                            {el?.internStd?.length &&
                              el?.internStd?.map((st, stIndex) => {
                                return (
                                  <Avatar
                                    onClick={() => setStudentSelected(st)}
                                    role="button"
                                    key={stIndex}
                                    alt={st.name}
                                    sx={{ height: 50, width: 50 }}
                                    src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${st.st_id}`}
                                  />
                                );
                              })}
                          </AvatarGroup>
                          <div className="text-end">
                            <span className="badge bg-secondary">
                              {matchOptions(internType, el?.type_intern)}
                            </span>
                          </div>
                        </div>

                        <div className="d-flex mt-2 justify-content-between align-items-center">
                          <div>
                            <div
                              className="btn btn-primary btn-sm"
                              onClick={() => onSelectDoc(el)}
                            >
                              ดูเอกสาร
                            </div>
                            <div
                              className="btn btn-info btn-sm ms-2"
                              onClick={() => onSelectDocResponse(el)}
                            >
                              แบบฟอร์มตอบรับ
                            </div>
                          </div>
                          {el?.idm_status == 3 && (
                            <div style={styles.stamp}>
                              รับโดย {el?.user_receive} เมื่อวันที่{" "}
                              {convertDateToString(el?.date_sent)}
                            </div>
                          )}

                          <input
                            name="req_id"
                            value={el?.idm_doc_id}
                            className="d-none"
                          />

                          <input
                            name="user"
                            value={profile?.id}
                            className="d-none"
                          />
                          {el?.internStd?.length &&
                            el?.internStd?.map((st, stIndex) => {
                              return (
                                <input
                                  name="st_id[]"
                                  value={st?.st_id}
                                  className="d-none"
                                />
                              );
                            })}
                        </div>
                      </div>
                      <input
                        className="d-none"
                        value={docTypeSelected}
                        name="doc_type"
                      />
                    </form>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      <ModalGetDocument
        isModaOpen={isModalGetDocOpen}
        setIsModalOpen={setIsModalGetDocOpen}
        cardSelected={cardSelected}
        docTypeSelected={docTypeSelected}
        setDocumentTypeSelected={setDocumentTypeSelected}
      />

      <DrawerView
        isOpen={isOpenDrawerFormRequest}
        setIsOpen={setIsOpenDrawerFormRequest}
        content={<FormReviewCompleted data={docSelected} />}
      />

      <DrawerView
        isOpen={isOpenDrawerFormResponse}
        setIsOpen={setIsOpenDrawerFormResponse}
        content={<FormResponse data={docSelected} />}
      />

      {displayProfile}
    </div>
  );
};

export default DocumentCompleted;
